<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
export default {};
</script>

<style lang="less">
@import './assets/css/main.css';
/* 深色主题 */
@import './assets/css/color-dark.css';
/* 浅绿色主题 */
/* @import "./assets/css/theme-green/color-green.css";    */
@import './assets/css/variables.less';

::-webkit-scrollbar {
    width: 6px;
}

::-webkit-scrollbar-thumb {
    background-color: @gray-one;
    border-radius: 10px;
}

::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #000;
}

body,
html {
    margin: 0;
    padding: 0;
}

.el-message__icon {
    font-size: 0.5rem !important;
}

@import './assets/css/variables.less';

.red {
    color: @alarm-color;
}

.green {
    color: @normal-color;
}

.container {
    background-color: @black-two;
}

.projcetCard {
    width: 100%;
    min-height: 500px;
    max-height: 500px;
    overflow-y: scroll;
    overflow-x: hidden;
    position: relative;

    .projectStyle {
        width: 100%;

        tr {
            height: 40px;
            text-align: left;
        }

        .projectHeader {
            font-size: 12px;
            background-color: @gray-two;
            color: @gray-one;
        }

        .projectBody {
            font-size: 14px;
        }

        .projectBody:hover {
            cursor: pointer;
            background-color: @black-two;
        }

        td,
        th {
            padding: 0 10px;
            border: none;
        }
    }
}
</style>
